module.exports = __webpack_public_path__ + "static/educative-code-running-poster-5f49abf3c1d3cb62cf312d9716e8d41e.jpg";